import { render, staticRenderFns } from "./GuardianDetails.vue?vue&type=template&id=26f361db&scoped=true"
import script from "./GuardianDetails.vue?vue&type=script&lang=js"
export * from "./GuardianDetails.vue?vue&type=script&lang=js"
import style0 from "./GuardianDetails.vue?vue&type=style&index=0&id=26f361db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f361db",
  null
  
)

export default component.exports